import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const FilterModal = styled.div<IProps>`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  max-height: calc(100vh - 50px);
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  position: relative;
  z-index: 0;
  background-color: #fff;
  ${mixin.flex({ direction: 'column', justify: 'flex-end', align: 'stretch' })};

  .filter-listbar {
    position: absolute;
    bottom: calc(constant(safe-area-inset-bottom) + 74px);
    bottom: calc(env(safe-area-inset-bottom) + 74px);
    height: 53px;
    width: 100%;

    .inner {
      border-top: 1px solid #eee;
      border-bottom: 1px solid #f6f6f6;
    }

    .area-left .btn {
      width: 29px;
      height: 29px;
    }
  }

  .tabs-main {
    ${mixin.flex({
      direction: 'column',
      justify: 'flex-end',
      align: 'stretch',
    })}
    overflow: hidden;

    > .tabs-label {
      ${mixin.flex({ justify: 'flex-start' })};
      padding: 0 20px;
      height: 43px;
      flex: none;
      position: sticky;
      top: 0;
      column-gap: 18px;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      overflow-y: hidden;
      overflow-x: auto;
      overscroll-behavior: contain auto;
      box-shadow: inset 0 -1px 0 #eee;
      scrollbar-width: none;
      -ms-overflow-style: none;
      z-index: 1;

      &::-webkit-scrollbar {
        display: none;
      }

      .tabs-tab {
        width: auto;
        height: inherit;
        color: #bbb;
        font-size: 15px;
        font-weight: 500;
        line-height: 130%;

        > span {
          position: relative;
        }

        &[aria-selected='true'] {
          color: #000;

          > span:after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background-color: #000;
            position: absolute;
            bottom: -12px;
          }
        }
      }

      .dot {
        &::after {
          content: '';
          display: inline-block;
          border-radius: 50%;
          background-color: #fa5500;
          width: 4px;
          height: 4px;
          margin-left: 2px;
          transform: translateY(-8px);
        }
      }
    }

    > .tabs-cont {
      position: relative;
      background-color: #fff;
      height: 392px;
      overflow: hidden;

      > .tabs-panel {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;

        > .box {
          padding: 20px 20px 0px 20px;
          &.coner-color,
          &.coner-style,
          &.coner-tpo {
            padding-bottom: 20px;
          }
        }
      }
    }
  }

  .box-msg {
    padding: 40px 0 60px;
    font-size: 16px;
    line-height: 130%;
    color: #999;
    text-align: center;
  }

  &.isFilterList {
    .tabs-main > .tabs-cont {
      padding-bottom: 53px;
    }

    .tabs-brand > .tabs-cont {
      height: 272px;

      ul {
        height: 279px;
      }

      .input + ul {
        height: 217px;
      }

      .input + [data-testid='virtuoso-scroller'] {
        height: 217px !important;
      }
    }
  }

  /* TPO는 1열 노출(총 24종 + 추후 확장 대응으로 탭 영역 스크롤) */
  .coner-tpo {
    .list .item {
      width: 100%;
    }
  }

  /* 상품정보는 상품 유형 / 혜택 두 그룹을 좌우로 나눠 각 1열로 노출한다 */
  .coner-benefit.type-group {
    ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};

    .flt-benefit-box {
      flex: 1 1 0;
      margin-top: 0;

      .list .item {
        width: 100%;
      }

      .title {
        margin-bottom: 8px;
        font-size: 13px;
        font-weight: 400;
        color: #555;
      }
    }
  }

  .coner-brand {
    .tabs-brand
      > .tabs-cont
      .ReactVirtualized__Grid__innerScrollContainer
      > li:not(.filter-chk) {
      display: block;
    }
    .checkbox {
      ${mixin.flex({ display: 'flex', justify: 'flex-start' })};
      .label {
        ${mixin.ellipsis(1)};
        ${mixin.flex({
          display: 'flex',
          wrap: 'wrap',
          align: 'center',
          justify: 'flex-start',
        })};
        .txt {
          ${mixin.ellipsis(1)};
          flex: 1 0 0%;
        }
      }
    }
  }

  &:not(.coner-brand) {
    .checkbox {
      ${mixin.flex({
        display: 'flex',
        justify: 'flex-start',
        align: 'flex-start',
      })};
    }
  }

  @keyframes loader10g {
    0% {
      background-color: rgba(255, 255, 255, 1);
    }
    25% {
      background-color: rgba(255, 255, 255, 0.5);
    }
    100% {
      background-color: rgba(255, 255, 255, 1);
    }
  }

  .modal-group-btn {
    .btn-primary {
      position: relative;
    }

    .loading {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: #000;
      display: none;
      pointer-events: none;

      span {
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #fff;
        margin: 0 3px;
        animation: loader10g 1.2s ease-in-out infinite;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }
        &:nth-child(3) {
          animation-delay: 0.4s;
        }
        &:nth-child(4) {
          animation-delay: 0.6s;
        }
      }
    }
  }

  &.isLoading {
    .tabs-main > .tabs-cont::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #fff;
      top: 0;
      left: 0;
      opacity: 0.8;
      z-index: 10;
    }

    .modal-group-btn .loading {
      ${mixin.flex({})};
    }
  }

  .error-cont.type-filter {
    height: auto;
    padding-top: 129.5px;
  }

  &:has(.tabs-cont .error-cont) {
    .modal-group-btn .loading {
      ${mixin.flex({})};
    }
  }

  &.is-old-app-iphonex {
    padding-bottom: 34px;

    .filter-listbar {
      bottom: 108px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .filter-listbar {
      height: ${mixin.pxToVw('53')};

      .area-left .btn {
        width: ${mixin.pxToVw('29')};
        height: ${mixin.pxToVw('29')};
      }
    }

    .tabs-main {
      > .tabs-label {
        padding: ${mixin.pxToVw('0 20')};
        height: ${mixin.pxToVw('43')};
        column-gap: ${mixin.pxToVw('18')};

        .tabs-tab {
          font-size: ${mixin.pxToVw('15')};

          &[aria-selected='true'] {
            > span:after {
              height: ${mixin.pxToVw('2')};
              bottom: ${mixin.pxToVw('-11')};
            }
          }
        }

        .dot {
          &::after {
            width: ${mixin.pxToVw('4')};
            height: ${mixin.pxToVw('4')};
            margin-left: ${mixin.pxToVw('2')};
            transform: translateY(${mixin.pxToVw('-8')});
          }
        }
      }

      > .tabs-cont {
        height: ${mixin.pxToVw('392')};

        > .tabs-panel {
          > .box {
            padding: ${mixin.pxToVw('20 20 0 20')};
            &.coner-color {
              padding-bottom: ${mixin.pxToVw('20')};
            }
          }
        }
      }
    }

    .coner-benefit.type-group {
      .flt-benefit-box {
        .title {
          margin-bottom: ${mixin.pxToVw('8')};
          font-size: ${mixin.pxToVw('13')};
        }
      }
    }

    .box-msg {
      padding: ${mixin.pxToVw('40 0 60')};
      font-size: ${mixin.pxToVw('16')};
    }

    &.isFilterList {
      .tabs-main > .tabs-cont {
        padding-bottom: ${mixin.pxToVw('53')};
      }

      .tabs-brand > .tabs-cont {
        height: ${mixin.pxToVw('272')};

        ul {
          height: ${mixin.pxToVw('279')};
        }

        .input + ul {
          height: ${mixin.pxToVw('217')};
        }

        .input + [data-testid='virtuoso-scroller'] {
          height: ${mixin.pxToVw('217')} !important;
        }
      }
    }

    .modal-group-btn {
      .loading {
        span {
          width: ${mixin.pxToVw('4')};
          height: ${mixin.pxToVw('4')};
          margin: ${mixin.pxToVw('0 3')};
        }
      }
    }

    .error-cont.network {
      padding-top: ${mixin.pxToVw('30')};

      .icon svg {
        width: ${mixin.pxToVw('96')};
        height: ${mixin.pxToVw('96')};
      }

      .title {
        font-size: ${mixin.pxToVw('18')};
        line-height: ${mixin.pxToVw('24')};
        margin-top: ${mixin.pxToVw('18')};
      }

      .detail {
        font-size: ${mixin.pxToVw('14')};
        line-height: ${mixin.pxToVw('20')};
        margin-top: ${mixin.pxToVw('10')};
      }

      .btn-link {
        width: ${mixin.pxToVw('160')};
        height: ${mixin.pxToVw('40')};
        font-size: ${mixin.pxToVw('14')};
        margin-top: ${mixin.pxToVw('24')};

        svg {
          width: ${mixin.pxToVw('18')};
          height: ${mixin.pxToVw('18')};
        }
      }
    }

    .error-cont.type-filter {
      padding-top: ${mixin.pxToVw('129.5')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 430px;
    max-height: 100%;
    height: 100vh;
    border-radius: 0;
    ${mixin.flex({
      direction: 'column',
      justify: 'flex-start',
      align: 'stretch',
    })};

    .popup-header {
      height: 48px;

      .inner-header {
        border-bottom: 0;
      }

      .btn-close {
        top: 12px;
        right: 16px;
      }
    }

    .filter-listbar {
      position: relative;
      bottom: auto;
      height: auto;
      min-height: 54px;
      max-height: 200px;
      overflow: hidden auto;
      scrollbar-width: thin;
      flex: none;
      margin-bottom: 0;

      .inner {
        padding: 12px 24px 12px 24px;
        ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
        gap: 6px;
      }

      .area-left {
        padding: 0;

        .btn {
          width: 30px;
          height: 30px;
        }
      }

      .list {
        ${mixin.flex({
          display: 'inline-flex',
          wrap: 'wrap',
          justify: 'flex-start',
          align: 'flex-start',
        })};
        gap: 6px 0;
        margin-left: -43px;

        .item:first-child {
          margin-left: 43px;
        }
      }
    }

    .tabs-main {
      flex: auto;
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-start',
        align: 'stretch',
      })};

      > .tabs-label {
        height: 48px;
        padding: 0 24px;
        column-gap: 12px;

        .tabs-tab {
          font-size: 17px;

          &[aria-selected='true'] {
            > span:after {
              bottom: -12px;
            }
          }
        }
      }

      > .tabs-cont {
        height: 100%;
        padding-bottom: 0 !important;

        .tabs-panel {
          height: 100%;

          > .box {
            padding: 20px 24px 0px 24px;
          }

          ::-webkit-scrollbar {
            width: 9px;
          }

          ::-webkit-scrollbar-thumb {
            border: 3px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            border-radius: 1em;
            background-color: #c4c4c4;
          }

          scrollbar-color: #c4c4c4;
          scrollbar-width: thin;

          .checkbox {
            cursor: pointer;
          }
        }
      }
    }

    .coner-benefit.type-group {
      column-gap: 0;

      .flt-benefit-box {
        .title {
          margin-bottom: 12px;
          font-size: 14px;
        }
      }
    }

    .coner-brand {
      overflow: hidden;
      height: 100%;
    }

    .box-msg {
      padding: 60px 0;
      font-size: 16px;
      line-height: 130%;
      color: #999;
      text-align: center;
    }

    &.isFilterList {
      .tabs-brand > .tabs-cont {
        .input + [data-testid='virtuoso-scroller'] {
          height: calc(100% - 70px) !important;
        }
      }
    }

    .error-cont.network {
      padding-top: 100px;

      .title {
        font-size: 16px;
        line-height: 22px;
      }

      .detail {
        font-size: 13px;
        line-height: 18px;
      }

      .btn-link svg + span {
        margin-right: 1px;
      }
    }

    .error-cont.type-filter {
      padding-top: 140px;
    }
  }
`;
